var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.994 0.164001C2.682 0.164001 0 2.852 0 6.164C0 9.476 2.682 12.164 5.994 12.164C9.312 12.164 12 9.476 12 6.164C12 2.852 9.312 0.164001 5.994 0.164001ZM6 10.964C3.348 10.964 1.2 8.816 1.2 6.164C1.2 3.512 3.348 1.364 6 1.364C8.652 1.364 10.8 3.512 10.8 6.164C10.8 8.816 8.652 10.964 6 10.964ZM6.3 3.164H5.4V6.764L8.55 8.654L9 7.916L6.3 6.314V3.164Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.2e035e2a7d089b174c6cddeadf7f304f.svg";
export { ForwardRef as ReactComponent };